import { UserQueries } from "@/application/queries/user.queries";
import { AuthService } from "@/application/services/user/auth.service";
import { NotFoundPage } from "@/interface/pages/not-found-page";
import PageLoader from "@/interface/pages/page-loader";
import { QueryClient } from "@tanstack/react-query";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const handleUnathenticatedAccess = (location?: string) => {
  throw redirect({
    to: "/auth/login",
    search: {
      from: location,
    },
  });
};

export const Route = createFileRoute("/_authenticated")({
  component: LayoutComponent,
  notFoundComponent: NotFoundPage,
  loader: async () => {
    const queryClient = new QueryClient();
    await queryClient.ensureQueryData({
      staleTime: Infinity,
      ...UserQueries.getCurrent(),
    });
  },
  staleTime: Infinity, // Keep the data cached for the lifetime of the app
  onError: () => handleUnathenticatedAccess(),
  pendingComponent: PageLoader,
  beforeLoad: ({ location }) => {
    const isAuthenticated = AuthService.getAuthenticatedState();
    if (!isAuthenticated) {
      throw redirect({
        to: "/auth/login",
        search: {
          from: location.href,
        },
      });
    }
  },
});

function LayoutComponent() {
  return <Outlet />;
}
